import { createSlice, SliceCaseReducers } from '@reduxjs/toolkit';
import { getInitialAppReduxState } from '.';
import { ICoreReduxState } from '../models';

const coreSlice = createSlice<ICoreReduxState, SliceCaseReducers<ICoreReduxState>>({
  name: 'core',
  initialState: getInitialAppReduxState().core,
  reducers: {
    signIn: (state, action) => (
      {
        ...state,
        isAuthenticated: true,
        token: action.payload.token,
        isTestingDashboardAuthenticated: false,
        testingDashboardToken: '',
      }),
    testingDashboardSignIn: (state, action) => (
      {
        ...state,
        isTestingDashboardAuthenticated: true,
        testingDashboardToken: action.payload.token,
        isAuthenticated: false,
        token: '',
      }),
    signOut: (state, action) => ({ ...state, isAuthenticated: false, token: '' }),
    updateTokenExp: (state, action) => ({ ...state, tokenExp: action.payload }),
    updateCurrentTime: (state, action) => ({ ...state, currentTime: action.payload }),
    updateRefreshToken: (state, action) => ({ ...state, refreshToken: action.payload.refreshToken }),
    reset: () => getInitialAppReduxState().core,
  },
});

export const {
  signIn, signOut, updateTokenExp, updateCurrentTime, updateRefreshToken, reset, testingDashboardSignIn,
} = coreSlice.actions;
export default coreSlice.reducer;
